module.exports = "/_next/static/images/fallback_L-14167d492143c7fbaa5ccb6c6ab05ca1.png";